import React, { useState, useEffect } from 'react'
import { Field, Form, withFormik } from 'formik'
import { withRouter } from 'react-router'
import _get from 'lodash/get'
import _includes from 'lodash/includes'
import Button from '../../_library/Button'
import { PasswordField } from '../../formik/Fields/PasswordField'
import { combineValidators, isEmailValidator, requiredValidator } from '../../../_common/core/validation'
import { SimpleField } from '../../formik/Fields'
import { customerVerificationCode } from '../../../_common/core/http_services/consumer'

const EmailPasswordForm = props => {
  const { isSubmitting, isValid, setFieldValue, values, errors, validateForm, handleSubmit, setError } = props
  const resettingPassword = values.isResettingPassword

  const [validatePasswordField, setValidatePasswordField] = useState(true)
  const [validateCodeField, setValidateCodeField] = useState(true)
  const [verificationCodeData, setVerificationCodeData] = useState(null)
  const [loadingCodeSend, setLoadingCodeSend] = useState(false)
  const [countdownTime, setCountdownTime] = useState(null)

  const timerInterval = React.useRef(null)

  useEffect(() => {
    const storedCountdownTime = localStorage.getItem('countdownTime')
    const storedCountdownStartTime = localStorage.getItem('countdownStartTime')
    const storedVerificationData = localStorage.getItem('verificationCodeData')
    if (storedCountdownTime && storedCountdownStartTime) {
      const currentTime = Math.floor(Date.now() / 1000)
      const elapsedTime = currentTime - parseInt(storedCountdownStartTime)
      const remainingTime = storedVerificationData
        ? Number(JSON.parse(storedVerificationData)?.expire_seconds || 0) - elapsedTime
        : 0

      if (remainingTime > 0) {
        setCountdownTime(remainingTime)
        startCountdown(remainingTime)
      } else {
        localStorage.removeItem('countdownTime')
        localStorage.removeItem('countdownStartTime')
        localStorage.removeItem('verificationCodeData')
      }
    }
    if (storedVerificationData) {
      setVerificationCodeData(JSON.parse(storedVerificationData))
    }

    return () => {
      if (timerInterval?.current) {
        clearInterval(timerInterval.current)
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const startCountdown = (initialTime = 600) => {
    setCountdownTime(initialTime)
    localStorage.setItem('countdownTime', initialTime.toString())
    timerInterval.current = setInterval(() => {
      setCountdownTime(prevTime => {
        if (prevTime <= 1) {
          clearInterval(timerInterval.current)
          localStorage.removeItem('countdownTime')
          localStorage.removeItem('countdownStartTime')
          localStorage.removeItem('verificationCodeData')
          setError(`Time Expired: You can request a new code by clicking the "Resend Code" button`)
          return null
        }
        localStorage.setItem('countdownTime', (prevTime - 1).toString())
        return prevTime - 1
      })
    }, 1000)
  }

  const handleGoBack = () => {
    props.history.goBack()
  }

  const handleForgotPasswordClick = () => {
    setValidatePasswordField(false)
    setFieldValue('isResettingPassword', !resettingPassword)
    resettingPassword && setFieldValue('submitMessage', '')

    validateForm({ email: values.email })
  }

  const handleBackToLoginClick = () => {
    clearInterval(timerInterval.current)
    setValidateCodeField(false)
    setValidatePasswordField(true)
    setVerificationCodeData(null)
    setFieldValue('isResettingPassword', false)
    setCountdownTime(null)
    localStorage.removeItem('verificationCodeData')
    localStorage.removeItem('countdownTime')
    localStorage.removeItem('countdownStartTime')

    validateForm({ email: values.email })
  }

  return (
    <Form className="margin-horizontal-25 sign-in-container">
      <Field
        type="email"
        name="email"
        label="Email"
        component={SimpleField}
        formclassname="field-wrapper email-input"
        validate={combineValidators(requiredValidator(), isEmailValidator('Invalid'))}
        touchedOnBlur
      />
      {!resettingPassword && !verificationCodeData && (
        <Field
          type="password"
          name="password"
          label="Password"
          component={PasswordField}
          className="password-input"
          validate={validatePasswordField ? requiredValidator() : undefined}
        />
      )}
      {Boolean(verificationCodeData) && (
        <Field
          // type="code"
          name="verification_code"
          label={
            <span>
              Verification Code
              {countdownTime !== null && (
                <span style={{ marginLeft: '10px', fontSize: '0.8em' }}>
                  ({Math.floor(countdownTime / 60)}:{(countdownTime % 60).toString().padStart(2, '0')})
                </span>
              )}
            </span>
          }
          component={SimpleField}
          formclassname="field-wrapper email-input"
          validate={validateCodeField ? requiredValidator() : undefined}
        />
      )}
      {resettingPassword ? (
        <div className="buttons-wrapper" style={{ margin: '38px 0 25px' }}>
          <Button
            type="submit"
            className={!isValid ? 'submit-disabled' : 'submit-button-login'}
            disabled={!isValid}
            loading={isSubmitting}
          >
            Send Reset Link
          </Button>
        </div>
      ) : (
        <div className="buttons-wrapper" style={{ margin: '38px 0 25px' }}>
          <Button type="button" className="back-button" disabled={isSubmitting} onClick={handleGoBack}>
            Back
          </Button>
          <Button
            type="submit"
            className={!isValid ? 'submit-disabled' : 'submit-button-login'}
            disabled={!isValid}
            loading={isSubmitting}
            onClick={() => {
              setValidatePasswordField(true)
            }}
          >
            Continue
          </Button>
        </div>
      )}
      {!resettingPassword && (
        <>
          <div style={{ textAlign: 'center' }}>
            <p style={{ color: '#666' }}>- or log in with code -</p>
          </div>
          <div className="buttons-wrapper" style={{ margin: '14px 0 25px' }}>
            <Button
              type="button"
              className={Boolean(errors.email) ? 'submit-disabled' : 'submit-button-login'}
              disabled={Boolean(errors.email)}
              loading={loadingCodeSend}
              onClick={async () => {
                if (!Boolean(errors.email)) {
                  setValidatePasswordField(false)
                  setLoadingCodeSend(true)
                  setFieldValue('submitMessage', '')

                  try {
                    const res = await customerVerificationCode(values.email)
                    setVerificationCodeData(res.data.data.attributes)
                    localStorage.setItem('verificationCodeData', JSON.stringify(res.data.data.attributes))
                    localStorage.setItem('countdownStartTime', Math.floor(Date.now() / 1000).toString())
                    setValidateCodeField(true)
                    setLoadingCodeSend(false)
                    startCountdown()
                  } catch (error) {
                    setLoadingCodeSend(false)
                  }
                  setTimeout(() => {
                    handleSubmit()
                  }, 0)
                }
              }}
            >
              {Boolean(verificationCodeData) ? 'Resend Code' : 'Send Code'}
            </Button>
          </div>
        </>
      )}
      {values.submitMessage && <div className="restore-password-response">{values.submitMessage}</div>}
      {Boolean(!verificationCodeData) && (
        <div className="restore-password">
          <span aria-hidden onClick={handleForgotPasswordClick}>
            {resettingPassword ? 'Back to Log In' : 'Forgotten your password?'}
          </span>
        </div>
      )}
      {Boolean(verificationCodeData) && (
        <div className="restore-password">
          <span aria-hidden onClick={handleBackToLoginClick}>
            Back to Log In with password
          </span>
        </div>
      )}
    </Form>
  )
}

const EmailPasswordFormFormik = withFormik({
  mapPropsToValues: props => {
    const searchParams = new URLSearchParams(window.location.search)
    const queryEmail = searchParams.get('email') || ''
    const stateEmail = props?.location?.state?.email || ''
    return {
      email: (props.email ?? stateEmail) || queryEmail,
      password: '',
      isResettingPassword: false,
      verification_code: '',
    }
  },
  handleSubmit: async (values, { props, setSubmitting, setFieldValue }) => {
    try {
      const res = await props.onSubmit(values)
      setSubmitting(false)

      if (!res.disableRedirect) {
        props.history.push('/')
      } else {
        setFieldValue('submitMessage', res.message)
      }
    } catch (e) {
      setSubmitting(false)

      const errorMessage = _get(e, 'response.data.message')
      if (_includes((errorMessage || '').toLowerCase(), 'expired')) {
        localStorage.removeItem('countdownTime')
        localStorage.removeItem('countdownStartTime')
      }
    }
  },

  displayName: 'EmailPasswordForm',
})(EmailPasswordForm)

const EmailPasswordFormRouter = withRouter(EmailPasswordFormFormik)

export default EmailPasswordFormRouter
